import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { TABLE } from '../constants';

export const isTable = isElementType(TABLE);
